import Profile from './Profile';

export default {
    show: <Profile />
};
